module.exports = __webpack_public_path__ + "static/media/aeps.c2d53963.svg";